module.exports = __webpack_public_path__ + "img/logo-tdf.d219bb37.jpg";